<template>
  <base-modal
    id="createGroup"
    size="sm"
    title
    :show="showCreate"
    @closed="onClose"
    @shown="onShown"
  >
    <base-heading class="pt-2">Create group</base-heading>
    <hr>
    <label for>Name</label>
    <input
      ref="input"
      v-model="groupName"
      type="text"
      class="form-control"
      @keyup.enter="createGroup"
    >

    <template slot="footer">
      <base-button
        class="mr-0"
        inverse
        @click="createGroup"
      >
        <base-loading
          v-if="loading"
        />
        <base-text
          v-else
        >
          Create
        </base-text>
      </base-button>
    </template>
  </base-modal>
</template>

<script>
import { sendToMixPanel } from '@/_utilities/seerMixPanel';
import { MIXPANEL_EVENTS } from '../../../_utilities/Enums';

export default {
  name: 'GroupCreate',
  props: {
    showCreate: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupName: '',
    };
  },
  methods: {
    open() {
      this.groupName = '';
    },
    onShown() {
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    onClose() {
      this.$emit('close');
    },
    createGroup() {
      sendToMixPanel(MIXPANEL_EVENTS.groupCreated, {
        account_id: this.$store.state.account.user.user.email,
        name: this.groupName,
      });

      this.$emit('create', {
        name: this.groupName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
